var windowId = '#addEmailDialog';
var closeId = '#addEmailDialogClose';
var okBtnId = '#addEmailDialogOk';
var promtInputId = '#addEmailDialogInput';
export function show(value) {
    // $('#promtTitle').text(title || 'Введите');
    return new Promise(function (resolve, reject) {
        $(windowId).addClass('modal-open');
        var $input = $(promtInputId);
        if (value)
            $input.val(value);
        $input.focus();
        $(promtInputId).on("input", function () {
            clearError();
        });
        $(okBtnId).on('click', function () {
            var promt = $(promtInputId).val();
            resolve(promt);
        });
        $(closeId).on('click', function () {
            clear();
            reject();
        });
        $input.on('keypress', function (e) {
            if (e.which === 13) {
                e.preventDefault();
                var promt = $(promtInputId).val();
                resolve(promt);
                clear();
            }
        });
    })
        .finally(function () {
        clear();
    });
}
export function close() {
    clear();
    $(windowId).removeClass('modal-open');
}
export function setError(message) {
    $(promtInputId).addClass('input-error');
    $('#inputEmailErrorText').html(message);
}
export function clear() {
    $(promtInputId).removeClass('input-error');
    $('#inputEmailErrorText').empty();
    $(promtInputId).val('');
}
export function clearError() {
    $(promtInputId).removeClass('input-error');
    $('#inputEmailErrorText').empty();
}
